export * as cards from '@wix/auto_sdk_workflows_cards/meta';
export * as phases from '@wix/auto_sdk_workflows_phases/meta';
export * as workflows from '@wix/auto_sdk_workflows_workflows/meta';
